<template>
    <div class="test-comment replied">
        <div v-if="repliesWithoutDeleted.length || isReply" class="test-comment-reply-line"
             :class="{'is-one-reply': repliesWithoutDeleted.length === 1 && !isReply, 'is-default': repliesWithoutDeleted.length > 1 && !isReply, 'is-reply': isReply}"
             :style="{height: replyLineHeight + 'px'}"
        ></div>
        <div class="test-comment-avatar" :class="{'no-avatar': !comment.avatar}">
            <icon-remove v-if="comment.deleted" class="text-second"/>
            <img :src="comment.avatar" :alt="comment.author" v-else-if="comment.avatar">
            <icon-user v-else/>
        </div>
        <div class="test-comment-content">
            <TestCommentEditor v-if="commentIsEdit"
                               :edit-comment="true" :comment="comment.comment"
                               @addcomment="editComment" @cancel="commentIsEdit = false"/>
            <div v-else class="test-comment-main" ref="mainComment"
                 :class="{'test-comment-removed': comment.deleted, 'test-comment-edited': comment.edited_at}">
                <div class="test-comment-header flex-v-center" v-if="!comment.deleted">
                    <div class="test-comment-header-content flex-v-center">
                        <div class="test-comment-author">{{ comment.author }}</div>
                        <div class="test-comment-date"> {{ timeAgo(comment.edited_at ? comment.edited_at : comment.created_at) }}</div>
                    </div>
                    <TestCommentOptions v-if="checkEditRemoveAvailable(comment.edited_at || comment.created_at ) && store.userCanComment"
                                        :comment-id="comment.id" @edit="showEditComment" @remove="showRemove(comment)"/>
                </div>
                <div class="test-comment-text" :class="{'test-comment-text-removed': comment.deleted}">
                    <span v-html="comment.comment"></span>
                    <span v-if="comment.edited_at" class="test-comment-edited-label">(відредаговано)</span>
                </div>
            </div>
            <div class="test-comment-footer" v-if="!comment.deleted">
                <div class="test-comment-like flex-v-center" @click="setVote(comment.id, 1)">
                    <icon-comment-like/>
                    {{ comment.good_votes }}
                </div>
                <div class="test-comment-dislike flex-v-center" @click="setVote(comment.id, 0)">
                    <icon-comment-dislike/>
                    {{ comment.bad_votes }}
                </div>
                <div class="test-comment-reply flex-v-center" v-if="store.user && store.user.id" @click="isReply = !isReply">
                    <icon-share class="test-comment-reply-icon"/>
                    Відповісти
                </div>
            </div>
            <TestCommentReply v-for="reply in commentReplies" :key="reply.id"
                              :reply="reply"
                              @setvote="setVote" @showreply="isReply = !isReply" @editreply="editComment"
                              @seteditreplyid="setReplyId" @showremove="showRemove"/>
            <div class="test-comment is-reply" v-if="repliesWithoutDeleted.length > 2">
                <a href="#" @click.prevent="showAllReplies = !showAllReplies" class="link all-replies-link">
                    <span v-if="showAllReplies">Згорнути відповіді</span>
                    <span v-else>Всі відповіді ({{ repliesWithoutDeleted.length - 2 }})</span>
                </a>
            </div>
            <div v-if="isReply" class="test-comment is-reply">
                <div class="test-comment-avatar">
                    <img :src="store.user.media[0].original_url" alt="avatar">
                </div>
                <div class="test-comment-content">
                    <test-comment-editor @addcomment="addReply" @cancel="isReply = false" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconCommentLike from '../../icons/IconCommentLike.vue';
import IconCommentDislike from '../../icons/IconCommentDislike.vue';
import IconShare from '../../icons/IconShare.vue';
import TestCommentEditor from './TestCommentEditor.vue';
import IconUser from '../../icons/IconUser.vue';
import TestCommentOptions from './TestCommentOptions.vue';
import IconModalClose from '../../icons/IconModalClose.vue';
import TestCommentReply from './TestCommentReply.vue';
import {tourniquetStore} from '../../../store/store';
import {timeAgo} from '../../helpers/helperFunctions';
import IconRemove from '../../icons/IconRemove.vue';
import {userIdentifyHelper} from "../../../helpers/UserIdentifyHelper";

export default {
    name: "TestComment",
    components: {
        IconRemove,
        TestCommentReply,
        IconModalClose,
        TestCommentOptions, IconUser, TestCommentEditor, IconShare, IconCommentDislike, IconCommentLike},
    props: ['comment', 'commentChildren', 'userData', 'testId'],
    setup() {
        const store = tourniquetStore();
        return {store};
    },
    data() {
        return {
            isReply: false,
            showAllReplies: false,
            commentIsEdit: false,
            replyCommentId: null,
            replyLineHeight: 0
        }
    },
    mounted() {
        this.setReplyLineHeight();
    },
    computed: {
        repliesWithoutDeleted() {
            if(this.commentChildren) {
                return this.commentChildren.filter(item => !item.deleted);
            }
        },
        commentReplies() {
            if(this.repliesWithoutDeleted) {
                return this.showAllReplies ? this.repliesWithoutDeleted : this.repliesWithoutDeleted.slice(0,2)
            }
        }
    },
    methods: {
        setReplyLineHeight() {
            this.replyLineHeight = this.$refs.mainComment.getBoundingClientRect().height + 20
        },
        timeAgo,
        checkEditRemoveAvailable(createdTime) {
            const createdTimeMinutes = Math.floor(new Date(createdTime).getTime() / (1000 * 60));
            const timeNowMinutes = Math.floor(new Date(Date.now()).getTime() / (1000 * 60));
            return timeNowMinutes - createdTimeMinutes < 30
        },
        setReplyId(id) {
            this.replyCommentId = id
        },
        showRemove(data) {
            this.store.setRemoveCommentData(data)
        },
        editComment(text, id) {
            let data = new FormData();
            data.append('comment', text);
            data.append('commentable_id', parseInt(this.testId));
            const commentId = id || this.comment.id;
            try {
                fetch(`/comments/${commentId}/update`, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': this.store.csrfToken,
                    },
                    body: data
                }).then(function(response) {
                    if(response.status === 403) {
                        alert("Час для редагування коментарю закінчився")
                        window.location.reload()
                        return false
                    }
                    return response.json();
                }).then((data) => {
                    this.$emit('updatecomment', commentId, data.data);
                    this.commentIsEdit = false;
                });
            } catch (error) {
                alert(error)
            }
        },
        showEditComment() {
            this.commentIsEdit = true;
        },
        setVote(id, reaction) {
            if(this.userData) {
                this.vote(id, reaction, this.userData.requestId, this.userData.visitorId);
            } else {
                this.getVisitorData().then(data => {
                    this.vote(id, reaction, data.requestId, data.visitorId);
                })
            }
        },
        vote(id, reaction, request, visitor) {
            fetch(`${window.location.origin}/api/v1/comment/${id}/vote`, {
                method: 'POST',

                headers: {
                    'Content-Type' : 'application/json'
                },
                body: JSON.stringify({
                    "vote": parseInt(reaction),
                    "request_id": request,
                    "visitor_id": visitor
                }),
            }).then((response) => {
                return response.json();
            }).then((data) => {
                this.$emit('updatelikes', id, data)
            }).catch((error) => {
                console.error('Error:', error);
            });
        },
        async getVisitorData() {
            return await userIdentifyHelper.get();
        },
        addReply(text) {
            this.isReply = false;
            this.$emit('addreply', text, this.comment.id);
            this.showAllReplies = true;
            this.setReplyLineHeight()
        }
    }
}
</script>

<style lang="scss">
@import "../../../../../sass/front/helpers";
.all-replies-link {
    margin: 0.8rem 0 0 2rem;
    font-size: 1.4rem;
}

.modal-footer {
    margin-top: 3.6rem;
    text-align: right;
}

.test-comment {
    padding-bottom: 2.8rem;

    @include responsive-below($sm) {
        padding-bottom: 1.8rem;
    }

    &-edited-label {
        color: #959595;
    }

    &.test-comment-removed {
        border: 1px solid #E9EBEF;
        padding: 1.4rem 1.4rem 1rem 1.4rem;
        border-radius: 1.2rem;
        margin-top: 2.6rem;

        .test-comment-main {
            padding: 0 1rem;
        }
    }

    &-edited {
        background: linear-gradient(104deg, rgba(67, 122, 252, 0.05) 0%, rgba(248, 228, 47, 0.05) 100%);
    }

    &-reply-line {
        width: 2px;
        background-color: #EFEFF2;
        position: absolute;
        left: 2rem;
        top: 4rem;

        &.is-one-reply {
            height: calc(100% - 17rem);
        }

        &.is-reply {
            height: calc(100% - 15rem) !important;
        }

        &.is-default {
            height: calc(100% - 9rem) !important;
        }


        @include responsive-below($sm) {
            left: 1.8rem;
            top: 3.4rem;
        }
    }

    &.replied {
        position: relative;

        .test-comment.is-reply {
            padding-top: 2.4rem;
            padding-bottom: 0;
            position: relative;

            @include responsive-below($sm) {
                padding-top: 1rem;
            }

            &:before {
                content: "";
                display: block;
                width: 3rem;
                height: 2rem;
                border: 2px solid #EFEFF2;
                position: absolute;
                left: calc(-3rem + 2px);
                border-radius: 0 0 0 10rem;
                border-top: 0;
                border-right: 0;

                @include responsive-below($sm) {
                    left: calc(-2.6rem + 2px);
                }
            }
        }
    }

    &-main {
        padding: 1.4rem 2rem;
        border-radius: 1.2rem;
        background-color: #fff;
        margin-bottom: 1rem;

        @include responsive-below($xs) {
            padding: 0.5rem 1rem;
        }

        &.test-comment-removed {
            margin-bottom: 3rem;
        }
    }

    &-header {
        justify-content: space-between;

        @include responsive-below($sm) {
            .dropdown {
                width: auto;
            }
        }

        &-content {
            gap: 0.8rem;
            margin-bottom: 0.5rem;

            @include responsive-below($xs) {
                flex-direction: column;
                gap: 0.4rem;

                &.flex-v-center {
                    align-items: flex-start;
                }
            }
        }
    }

    &-author {
        font-weight: 500;

        @include responsive-below($xs) {
            font-size: 1.2rem;
        }
    }

    &-date {
        color: #aaa;
        font-weight: 300;
        font-size: 1.2rem;

        @include responsive-below($xs) {
            font-size: 1rem;
        }
    }

    &-text {
        color: #3B3D43;
        font-weight: 300;
        word-break: break-word;

        &-removed {
            color: #959595;
        }

        p {
            font-weight: 300;
        }

        a {
            color: #4578EB;
        }

        @include responsive-below($xs) {
            font-size: 1.2rem;
        }
    }

    &-footer {
        display: flex;
        align-items: center;
        font-size: 1.2rem;
    }

    &-reply {
        margin-left: 3rem;
        font-size: 1.1rem;
        cursor: pointer;
        font-weight: 300;
        color: #3B3D43;
        gap: .6rem;

        &-icon {
            color: #DADADA;
            width: 1.2rem;
        }
    }

    &-like {
        cursor: pointer;
        gap: .6rem;
        margin-left: 1.4rem;
    }

    &-dislike {
        margin-left: 2rem;
        color: $text-second;
        gap: .6rem;
        cursor: pointer;
    }
}

</style>
